import { connect } from 'react-redux';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_EDUCATION_GOAL_API } from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';
import SchoolSearchView from './SchoolSearchView';
import nextIteratorsSelector from './SchoolSearchSelector';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);
  const goalsList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(goalsList, childFirstName);
  const isEditingGoal = !!childEducationGoal.Id;

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    ClientId: clientId,
    Name: childFirstName,
  };

  return {
    clientId,
    isEditingGoal,
    educationGoal,
    nextIterators: nextIteratorsSelector(state, ownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: (data, educationGoal) => ({ [BACKEND_EDUCATION_GOAL_API]: educationGoal }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SchoolSearchView);
